import React, { useEffect, useState } from "react";
import baseUrl from "../../../../api/baseUrl";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SaveIcon from "@mui/icons-material/Save";

function NavTime({ setformData }: any) {
  const [timeData, settimeData] = useState({
    from: "09:00",
    to: "17:00",
    timeDuration: "30",
  });

  useEffect(() => {
    baseUrl
      .get("/clinic/getTimeData")
      .then((response) => {
        if (response.data.data.startTime) {
          setformData((prevData: any) => ({
            ...prevData,
            from: response.data.data.startTime,
            to: response.data.data.endTime,
          }));
          settimeData((prevData: any) => ({
            ...prevData,
            from: response.data.data.startTime,
            to: response.data.data.endTime,
          }));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setformData]);

  const handleChange = (e: any) => {
    settimeData({ ...timeData, [e.target.name]: e.target.value });
  };

  const handleTimeSave = () => {
    baseUrl
      .post("/clinic/addTimeData", {
        startTime: timeData.from,
        endTime: timeData.to,
      })
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden">
      <div className="px-6 py-4 bg-gradient-to-r from-primary to-primaryLight flex items-center gap-3">
        <AccessTimeIcon className="text-white" sx={{ fontSize: 24 }} />
        <h3 className="text-lg font-bold text-white">Clinic Hours</h3>
      </div>
      <div className="p-6">
        <div className="flex flex-col md:flex-row md:items-end gap-4">
          <div className="flex-1">
            <label className="block text-sm font-medium text-slate-700 mb-1.5">
              From
            </label>
            <input
              type="time"
              onChange={handleChange}
              value={timeData.from}
              name="from"
              className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
            />
          </div>
          <div className="flex-1">
            <label className="block text-sm font-medium text-slate-700 mb-1.5">
              To
            </label>
            <input
              type="time"
              onChange={handleChange}
              value={timeData.to}
              name="to"
              className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
            />
          </div>
          <button
            onClick={() => handleTimeSave()}
            className="flex items-center gap-2 px-6 py-2.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-xl hover:shadow-lg hover:shadow-primary/20 transition-all font-medium"
          >
            <SaveIcon sx={{ fontSize: 20 }} />
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default NavTime;
